// Maps backend internal statuses to main frontend categories
export const STATUS_CATEGORY_MAP = {
  // Milestone descriptions mapped to internal status codes
  "BOOKED": "BOOKED",
  "Shipper Pick Up": "SHIPPER_PICK_UP",
  "Export Gate-In": "GATED_IN",
  "Loaded on Vessel": "LOADED",
  "Vessel Sailed (Departure)": "IN_TRANSIT",
  "Container Discharged": "DISCHARGED",
   "Delivery Order (D.O.) Collected": "READY_FOR_PICKUP",
  "Delivery Order (D.O.) Issued": "READY_FOR_PICKUP",
  "Consignee Gate-Out (Pick Up)": "DELIVERED",
  "Container Return (Empty)": "COMPLETED",
  "Detention (Detention Charges)": "COMPLETED",  
};

export function mapStatusToCategory(internalStatus) {
  return STATUS_CATEGORY_MAP[internalStatus] || internalStatus;
}
